import { AnyRoute, createRoute, lazyRouteComponent, notFound } from '@tanstack/react-router'
import { ApiError } from 'commons/types/api'
import { isEqual } from 'lodash'
import { getAdverseMediaDetails } from '~bank-adverse-media/service/getAdverseMediaDetails'
import { AdverseMediaDetailsType } from '~bank-adverse-media/types'

import { SearchParamsDetailsSchema } from './SearchParamsDetailsSchema'

export const searchCaseRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: '$id',
    validateSearch: (search) => SearchParamsDetailsSchema.parse(search),
    loaderDeps: ({ search }) => ({
      search: { ...search },
      isChanged: !isEqual(SearchParamsDetailsSchema.parse({}), search)
    }),
    loader: async ({ params, deps }) => {
      let data: AdverseMediaDetailsType
      try {
        data = await getAdverseMediaDetails(Number(params.id), deps.search)
      } catch (e: unknown) {
        if (e instanceof ApiError && e.httpCode === 400) {
          throw notFound()
        }
        throw e
      }
      return data
    },
    component: lazyRouteComponent(() => import('./SearchCase'))
  })
